import { render, staticRenderFns } from "./TouristsKids.vue?vue&type=template&id=57452812"
import script from "./TouristsKids.vue?vue&type=script&lang=js"
export * from "./TouristsKids.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports